import InputTags, { IInputTag, IProps } from './InputTags';

export type { IInputTag, IProps };

export { InputTags };
export default InputTags;
